import { Button } from '@material-ui/core';
import type { FC } from 'react';
import { useState } from 'react';

import styles from './ReadMore.module.css';
interface Props {
  children: any;
}

export const ReadMore: FC<Props> = ({ children }) => {
  const [isHidden, setIsHidden] = useState(true);
  return (
    <>
      <div className={isHidden ? styles.hidden : styles.visible}>
        {children}
      </div>
      <Button
        className={`${styles.buttonColor}`}
        size="small"
        onClick={() => setIsHidden(!isHidden)}
      >
        {isHidden ? '⬇ Show More' : '⬆ Show Less'}
      </Button>
    </>
  );
};
